module.exports = __webpack_public_path__ + "img/cushman-wakefield.cbd3027a.webp";